export function safeHref(value: string | null | undefined): string | undefined {
    if (!value) return undefined;
    try {
        const url = new URL(value);
        return url.protocol === 'https:' || url.protocol === 'http:' ? value : undefined;
    } catch {
        return undefined;
    }
}
